<script setup lang="ts">
import LanguageSwitch from '@src/features/language-switch/LanguageSwitch.vue';
import MainNavigation from '@src/features/main-navigation/MainNavigation.vue';
import NetworkSwitch from '@src/features/network-switch/NetworkSwitch.vue';
import WalletConnect from '@src/features/wallet/WalletConnect.vue';
import AppLogo from '@src/shared/ui/app-logo/AppLogo.vue';
</script>

<template>
	<header class="flex max-w-7xl mx-auto px-6 sm:px-4 pt-15 pb-10 sm:pt-10 justify-between w-full">
		<div class="flex items-center gap-6">
			<AppLogo />
			<MainNavigation />
		</div>
		<div class="flex items-center gap-2.5">
			<LanguageSwitch />
			<NetworkSwitch />
			<WalletConnect />
		</div>
	</header>
</template>
